import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot, UrlTree } from '@angular/router';

import { Observable } from 'rxjs';

import { ClientOnlyComponent } from '@fcom/common';

export interface DeactivationGuarded {
  canDeactivate(nextUrl: string): Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable()
export class PassengerDetailsDeactivateGuard implements CanDeactivate<ClientOnlyComponent<DeactivationGuarded>> {
  canDeactivate(
    component: ClientOnlyComponent<DeactivationGuarded>,
    _currentRoute: ActivatedRouteSnapshot,
    _currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean | UrlTree> | boolean {
    return component.componentReference.instance.canDeactivate(nextState.url);
  }
}
